import React from "react";
import { NavLink } from "react-router-dom";

import AliceCarousel from "react-alice-carousel";
import prev_icon from "../../../style/images/home_corousel_prev.png";
import next_icon from "../../../style/images/home_corousel_next.png";
import "react-alice-carousel/lib/alice-carousel.css";

// Desktop WebP
import c1WebP from "../../../style/images/home_carousel_1.webp";
import c2WebP from "../../../style/images/home_carousel_2.webp";
import c3WebP from "../../../style/images/home_carousel_3.webp";
import c4WebP from "../../../style/images/home_carousel_4.webp";

// Desktop PNG fallbacks
import c1PNG from "../../../style/images/home_carousel_1.png";
import c2PNG from "../../../style/images/home_carousel_2.png";
import c3PNG from "../../../style/images/home_carousel_3.png";
import c4PNG from "../../../style/images/home_carousel_4.png";

// Mobile WebP
import m1WebP from "../../../style/images/home_carousel_mobile_1.webp";
import m2WebP from "../../../style/images/home_carousel_mobile_2.webp";
import m3WebP from "../../../style/images/home_carousel_mobile_3.webp";
import m4WebP from "../../../style/images/home_carousel_mobile_4.webp";

// Mobile PNG fallbacks
import m1PNG from "../../../style/images/home_carousel_mobile_1.png";
import m2PNG from "../../../style/images/home_carousel_mobile_2.png";
import m3PNG from "../../../style/images/home_carousel_mobile_3.png";
import m4PNG from "../../../style/images/home_carousel_mobile_4.png";

const renderPrevButton = ({ isDisabled }) => (
  <button
    className="carousel-button carousel-button-prev"
    disabled={isDisabled}
    type="button"
  >
    <img src={prev_icon} alt="previous slide" />
  </button>
);

const renderNextButton = ({ isDisabled }) => (
  <button
    type="button"
    className="carousel-button carousel-button-next"
    disabled={isDisabled}
  >
    <img src={next_icon} alt="next slide" />
  </button>
);

const renderDotsItem = ({ isActive }) => (
  <div className={`carousel-dot ${isActive ? "active" : ""}`} />
);

// Reusable background image component with WebP + PNG fallback + responsive
const BgPicture = ({
  desktopWebP,
  desktopPNG,
  mobileWebP,
  mobilePNG,
  priority,
}) => (
  <picture>
    <source media="(max-width: 900px)" srcSet={mobileWebP} type="image/webp" />
    <source media="(max-width: 900px)" srcSet={mobilePNG} />
    <source srcSet={desktopWebP} type="image/webp" />
    <img
      className="homeCarousel_item_bg"
      src={desktopPNG}
      alt=""
      aria-hidden="true"
      fetchpriority={priority ? "high" : "auto"}
      loading={priority ? "eager" : "lazy"}
    />
  </picture>
);

const FirstItem = ({ lang }) => (
  <div className="homeCarousel_item first">
    <BgPicture
      desktopWebP={c1WebP}
      desktopPNG={c1PNG}
      mobileWebP={m1WebP}
      mobilePNG={m1PNG}
      priority={true}
    />
    <div className="homeCarousel_item_first_text">
      <div className="homeCarousel_item_first_wrapper">
        {lang === "ua" ? (
          <>
            <h1 className="homeCarousel_item_first_text_title">
              МЕБЛЕВА ФУРНІТУРА
            </h1>
            <span>Ідеальна фурнітура для вашого дому.</span>
            <span>
              Наша меблева фурнітура поєднує стиль та надійність. Сучасні петлі,
              елегантні ручки та плавні направляючі – все для вашого комфорту та
              затишку. Створіть ідеальні меблі з нами!
            </span>
            <NavLink
              className="homeCarousel_item_first_text_link"
              to={`/${lang}/catalog`}
            >
              ДОКЛАДНІШЕ
            </NavLink>
          </>
        ) : (
          <>
            <h1 className="homeCarousel_item_first_text_title">
              МЕБЕЛЬНАЯ ФУРНИТУРА
            </h1>
            <span>Идеальная фурнитура для вашего дома.</span>
            <span>
              Наша мебельная фурнитура совмещает стиль и надежность. Современные
              петли, элегантные ручки и плавные направляющие – все для вашего
              комфорта и уюта. Создайте идеальную мебель с нами!
            </span>
            <NavLink
              className="homeCarousel_item_first_text_link"
              to={`/${lang}/catalog`}
            >
              ПОДРОБНЕЕ
            </NavLink>
          </>
        )}
      </div>
    </div>
  </div>
);

const SecondItem = ({ lang }) => (
  <div className="homeCarousel_item second">
    <BgPicture
      desktopWebP={c2WebP}
      desktopPNG={c2PNG}
      mobileWebP={m2WebP}
      mobilePNG={m2PNG}
    />
    <div className="homeCarousel_item_second_text">
      {lang === "ua" ? (
        <>
          <h2 className="homeCarousel_item_second_text_title">
            Найбільш функціональні
          </h2>
          <span>Завіси для корпусних меблів</span>
          <span>які існують у кожному куточку нашого життя</span>
          <NavLink
            className="homeCarousel_item_second_text_link"
            to={`/${lang}/catalog/44`}
          >
            КУПИТИ
          </NavLink>
        </>
      ) : (
        <>
          <h2 className="homeCarousel_item_second_text_title">
            Наиболее функциональные
          </h2>
          <span>Петли для корпусной мебели</span>
          <span>существующих в каждом уголке нашей жизни</span>
          <NavLink
            className="homeCarousel_item_second_text_link"
            to={`/${lang}/catalog/44`}
          >
            КУПИТЬ
          </NavLink>
        </>
      )}
    </div>
  </div>
);

const ThirdItem = ({ lang }) => (
  <div className="homeCarousel_item third">
    <BgPicture
      desktopWebP={c3WebP}
      desktopPNG={c3PNG}
      mobileWebP={m3WebP}
      mobilePNG={m3PNG}
    />
    <div className="homeCarousel_item_third_text">
      {lang === "ua" ? (
        <>
          <h3 className="homeCarousel_item_third_text_title">ДУЖЕ МIЦНI</h3>
          <span>Направляючі для корпусних меблів</span>
          <span>
            які забезпечують легкий доступ до предметів, просто відкривши
            шухляду.
          </span>
          <NavLink
            className="homeCarousel_item_third_text_link"
            to={`/${lang}/catalog/45`}
          >
            КУПИТИ
          </NavLink>
        </>
      ) : (
        <>
          <h3 className="homeCarousel_item_third_text_title">ОЧЕНЬ КРЕПКИЙ</h3>
          <span>Направляющие для корпусной мебели</span>
          <span>
            которые обеспечивают легкий доступ к предметам, просто открыв ящик.
          </span>
          <NavLink
            className="homeCarousel_item_third_text_link"
            to={`/${lang}/catalog/45`}
          >
            КУПИТЬ
          </NavLink>
        </>
      )}
    </div>
  </div>
);

const FourthdItem = ({ lang }) => (
  <div className="homeCarousel_item fourth">
    <BgPicture
      desktopWebP={c4WebP}
      desktopPNG={c4PNG}
      mobileWebP={m4WebP}
      mobilePNG={m4PNG}
    />
    <div className="homeCarousel_item_fourth_text">
      {lang === "ua" ? (
        <>
          <h4 className="homeCarousel_item_fourth_text_title">
            ПРИКРАСА ДЛЯ ЖИТЛА
          </h4>
          <span>Меблеві ручки</span>
          <span>
            найпомітніший аксесуар для шаф, гардеробів і висувних ящиків
          </span>
          <NavLink
            className="homeCarousel_item_fourth_text_link"
            to={`/${lang}/catalog/42`}
          >
            КУПИТИ
          </NavLink>
        </>
      ) : (
        <>
          <h2 className="homeCarousel_item_fourth_text_title">
            УКРАШЕНИЕ ДЛЯ ЖИЛЬЯ
          </h2>
          <span>Мебельные ручки</span>
          <span>
            самый заметный аксессуар для шкафов, гардеробов и выдвижных ящиков
          </span>
          <NavLink
            className="homeCarousel_item_fourth_text_link"
            to={`/${lang}/catalog/42`}
          >
            КУПИТЬ
          </NavLink>
        </>
      )}
    </div>
  </div>
);

const HomeСarousel = ({ lang }) => (
  <div className="homeCarousel">
    <AliceCarousel
      mouseTracking
      autoPlay
      autoPlayInterval={5000}
      animationDuration={1000}
      infinite
      items={[
        <FirstItem lang={lang} />,
        <SecondItem lang={lang} />,
        <ThirdItem lang={lang} />,
        <FourthdItem lang={lang} />,
      ]}
      renderPrevButton={renderPrevButton}
      renderNextButton={renderNextButton}
      renderDotsItem={renderDotsItem}
      responsive={{
        0: { items: 1 },
      }}
      controlsStrategy="responsive"
    />
  </div>
);

export default HomeСarousel;
